import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import Select from "react-select";
import urls from "../../../Utils/urls";
import {
  BlurWrapper,
  customStylesForMultiSelect,
  EyeIconWrapper,
  FloatLabel,
  LoadingButton,
  SpinnerBlock,
} from "../../../Utils/CustomComponent";
import axios from "../../../axios";
import { toast } from "react-toastify";
import { commonToast, reportListConverter } from "../../../Utils";
import CustomBreadCrumbs from "../../../components/CustomBreadCrumbs";
// import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import FormBox from "../../../components/FormBox/FormBox";
import moment from "moment";
import FrequencyForm from "./FrequencyForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadingTypes } from "../../../Utils/constant";
import { fetchScheduledReportDetailByID } from "../../../store/reducers/reportDocumentSlice/api";
import { useAbortController } from "../../../hooks/useAbortController";

const defaultValues = {
  repeat: false,
  deliveryMethods: "email",
};
const ScheduleReport = () => {
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const scheduledReportDetailsByIdData = useSelector(
    (state) => state.reportDocument.scheduledReportDetailsById.data,
  );
  // const scheduledReportData = useSelector(
  //   (state) => state.reportDocument.scheduledReportDetails.data,
  // );
  const scheduledReportData = scheduledReportDetailsByIdData?.[0]?.reportData;
  const scheduledReportDetailsByIdStatus = useSelector(
    (state) => state.reportDocument.scheduledReportDetailsById.status,
  );

  // console.log({ scheduledReportDetailsByIdData });
  const dispatch = useDispatch();
  const location = useLocation();
  const { signal } = useAbortController();
  const prefilled = location?.state?.prefilled || false;
  const reportId = location?.state?.reportId;
  const selectedReport = reportListConverter(
    useSelector((state) => state.RS_Authentication.reportList),
  );

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues,
  });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "emails",
  });

  const repeatValue = watch("repeat");

  useEffect(() => {
    if (reportId) {
      dispatch(fetchScheduledReportDetailByID({ signal, reportId }));
    }
  }, []);

  useEffect(() => {
    if (reportId && scheduledReportDetailsByIdStatus === loadingTypes.idle) {
      dispatch(fetchScheduledReportDetailByID({ signal, reportId }));
    }
  }, [reportId, scheduledReportDetailsByIdStatus]);

  useEffect(() => {
    if (
      prefilled &&
      (scheduledReportData?.report_id || scheduledReportData?.id)
    ) {
      const today = new Date();
      const currentYear = today.getFullYear(); // e.g., 2025
      const currentMonth = today.getMonth() + 1; // 0-based, so +1 for 1–12

      Object.entries(scheduledReportData?.parameterDetails?.jsonInput).forEach(
        ([key, value]) => {
          if (key === "repeat") {
            console.log(key, ":", value)
            setValue(key, value);
          } else {
            setValue(key, `${value}`);
          }
        },
      );

      Object.entries(scheduledReportData?.report_details).forEach(
        ([key, value]) => {
          if (key === "Frequency") {
            setValue("frequeRepeat", value?.Repeat);
            setValue(
              "frequeDate",
              `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(
                value.Date,
              ).padStart(2, "0")}`,
            );
            setValue("frequeDay", `${value?.Day}`);
            setValue("frequeTime", to24HourFormat(value?.Time));
          } else if (key === "emails") {
            const emailArray = value
              ?.split(",")
              ?.filter(Boolean)
              ?.map((email) => ({ email }));

            replace(emailArray);
          } else if (key === "time") {
            setValue("time", to24HourFormat(value));
          } else if (key === "repeat") {
            setValue("repeat", value);
          } else {
            setValue(key, `${value}`);
          }
        },
      );
    }
  }, [prefilled, scheduledReportData, replace, setValue]);

  const userId = localStorage.getItem("apex_userid");
  const reportDetailsInfoForScheduledReports = JSON.parse(
    localStorage.getItem("reportDetailsInfoForScheduledReports"),
  );
  // console.log({ reportDetailsInfoForScheduledReports });

  const [loading, setLoading] = useState(false);
  const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
    .value;
  const repeat = watch("repeat");
  const reportFormat = watch("reportFormat");
  const deliveryMethods = watch("deliveryMethods");

  const deliveryMethodsOptions = [
    { label: "Emailed Report", value: "email" },
    { label: "File Transfer Protocol", value: "FTP" },
    // { label: "Dropbox", value: "dropbox" },
    // { label: "OneDrive", value: "onedrive" },
    // { label: "Google Drive", value: "googleDrive" },
  ];
  const updatedOptions = prefilled
    ? scheduledReportData?.parameterOptions
    : reportDetailsInfoForScheduledReports?.propState || [];

  const onSubmit = async ({
    frequeRepeat,
    frequeDate,
    frequeDay,
    frequeTime,
    ...data
  }) => {
    if (data.emails.some((emailObj) => emailObj.email)) setLoading(true);

    const id = toast.loading("Schedule Report Pending");

    try {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      };
      data["Frequency"] = {
        Repeat: frequeRepeat,
        Date:
          frequeRepeat === "M"
            ? frequeDate
              ? new Date(frequeDate).getDate()
              : ""
            : "",
        Day: frequeRepeat === "W" ? frequeDay : "",
        Time: frequeTime ? moment(frequeTime, "HH:mm").format("hh:mm A") : "",
      };

      const validEmails = data.emails
        .map((emailObj) => emailObj.email)
        .filter((email) => email.length);

      const processedValidEmails = validEmails.join(",");
      data.emails = processedValidEmails;

      const newdata = {
        ...data,
        date: moment(data?.date).isBefore(moment(), "day")
          ? moment().format("YYYY-MM-DD")
          : moment(data?.date).format("YYYY-MM-DD"),
        time: moment(data.time, "HH:mm").format("hh:mm A"),
      };

      const payload = () => {
        const payObj = {};
        updatedOptions?.forEach((data) => {
          if (data.type === "date") {
            payObj[data.field] = moment(data.value).format("DD/MM/yyyy");
          } else if (data.type === "lenderSelect") {
            payObj[data.field] = data?.value?.label?.split(":")[1].trim(" ");
          } else {
            payObj[data.field] = !isNaN(data.value)
              ? Number(data.value)
              : data.value || "";
          }
        });

        return {
          // reportname: reportDetailsInfoForScheduledReports?.report?.value,
          jsonInput: {
            lenderID: reportDetailsInfoForScheduledReports?.lenderID
              ?.map((data) => data.value)
              .join(" "),
            ...payObj,
          },
          report_id: reportDetailsInfoForScheduledReports?.report?.report_id,
          reportname: reportDetailsInfoForScheduledReports?.report?.value,
        };
      };

       const payloadForUpdateReport = () => {
         const payObj = {};
         scheduledReportData?.parameterOptions?.forEach((data) => {
           if (data.type === "date") {
             payObj[data.field] = moment(data.value).format("DD/MM/yyyy");
           } else if (data.type === "lenderSelect") {
             payObj[data.field] = data?.value?.label?.split(":")[1].trim(" ");
           } else {
             payObj[data.field] = !isNaN(data.value)
               ? Number(data.value)
               : data.value || "";
           }
         });

         return {
           // reportname: reportDetailsInfoForScheduledReports?.report?.value,
           jsonInput: {
             lenderID: scheduledReportData.selectedAccounts
               ?.map((data) => data.value)
               .join(" "),
             ...payObj,
           },
           report_id: scheduledReportData.report_id,
           reportname: scheduledReportData.report_details.report_custom_name,
         };
       };

      await axios.post(
        urls.reportsNDocuments.postScheduleReport(),
        {
          user_id: userId,
          id: reportId ? scheduledReportData?.id : null,
          user_role: userRole,
          report_type: "SCHEDULED",
          is_active: "Y",
          report_details: newdata,
          // parameterDetails: reportDetailsInfoForScheduledReports,
          parameterDetails: reportId
            ? payloadForUpdateReport()
            : payload(),
          report_id: reportId
            ? scheduledReportData?.report_id
            : reportDetailsInfoForScheduledReports?.report?.report_id,
          reportname: reportId
            ? scheduledReportData?.reportname
            : reportDetailsInfoForScheduledReports?.report?.value,
          parameterOptions: updatedOptions,
          selectedAccounts: reportId
            ? scheduledReportData?.selectedAccounts
            : reportDetailsInfoForScheduledReports?.lenderID,
          selectedReportLabel: reportId
            ? scheduledReportData?.selectedReportLabel
            : reportDetailsInfoForScheduledReports?.report?.label,
        },
        headers,
      );

      setLoading(false);
      toast.update(id, {
        render: "Schedule Report Success",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      navigate("/reports-and-documents");
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  useEffect(() => {
    register("reportFormat", { required: true });
    register("deliveryMethods", { required: true });
    setValue("repeatsEvery", 1);
  }, [register, setValue]);

  useEffect(() => {
    if (Boolean(repeatValue)) {
      setValue("customRepeats", 1);
    } else {
      setValue("customRepeats", 0);
    }
  }, [register, setValue, repeatValue]);

  const handleChange = (e) => {
    setValue("reportFormat", e.value);
  };
  const handleChangeDeliveryMethod = (e) =>
    setValue("deliveryMethods", e.value);
  const handleChangeRepeatsDurationWatch = (e) =>
    setValue("repeatsDuration", e.value);
  const handleChangeOnDay = (e) => setValue("onDay", e.value);

  if (scheduledReportDetailsByIdStatus === loadingTypes.loading) {
    return (
      <div className="row">
        <SpinnerBlock height={"10vh"} />
      </div>
    );
  }

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Reports & Documents", link: "/reports-and-documents" },
            { title: "Run New Report", link: "/run-new-report" },
            { title: "ScheduleReport", link: "" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <Form className="row" onSubmit={handleSubmit(onSubmit)}>
              <Form.Group controlId="formBasicEmail" className="col-sm-6">
                <div className="row mb-5">
                  <div
                    className={
                      errors.time ? "text-error border-error col" : "col"
                    }
                  >
                    <Form.Label className="mt-5">{"Report Name"}</Form.Label>
                    <Form.Control
                      {...register("report_custom_name", { required: true })}
                      type={"report_custom_name"}
                      placeholder=""
                      className={errors.time ? "text-error border-error" : ""}
                    />
                  </div>
                </div>
                <div className="row mb-5">
                  <div
                    className={
                      errors.time ? "text-error border-error col" : "col"
                    }
                  >
                    <Form.Label className="mt-5">{"Date"}</Form.Label>
                    <Form.Control
                      {...register("date", { required: true })}
                      type={"date"}
                      placeholder=""
                      className={errors.time ? "text-error border-error" : ""}
                    />
                  </div>
                  <div
                    className={
                      errors.time ? "text-error border-error col" : "col"
                    }
                  >
                    <Form.Label className="mt-5">{"Time"}</Form.Label>
                    <Form.Control
                      {...register("time", { required: true })}
                      type={"time"}
                      placeholder=""
                      className={errors.time ? "text-error border-error" : ""}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "50px" }} className=" mb-3 d-flex">
                  <Form.Check
                    type="checkbox"
                    {...register("repeat")}
                    className={
                      errors.repeat ? "text-error border-error me-3" : "me-3"
                    }
                  />
                  <Form.Label
                    className={errors.repeat ? "text-error border-error" : ""}
                  >
                    Repeat
                  </Form.Label>
                </div>

                {repeat && (
                  <FrequencyForm
                    register={register}
                    watch={watch}
                    errors={errors}
                  />
                )}

                <div className="mb-5">
                  <Form.Label
                    className={
                      errors.reportFormat ? "text-error border-error" : ""
                    }
                  >
                    Report Format
                  </Form.Label>
                  <Select
                    name="reportFormat"
                    options={reportFormatOptions}
                    // value={reportFormat ? reportFormat.label : null}
                    value={
                      reportFormatOptions.filter(
                        (el) => reportFormat === el.value,
                      )[0]
                    }
                    onChange={handleChange}
                    className={
                      errors.reportFormat ? "text-error border-error" : ""
                    }
                    classNamePrefix="select"
                  />
                </div>
                <div className="mb-5">
                  <Form.Label
                    className={
                      errors.deliveryMethods ? "text-error border-error" : ""
                    }
                  >
                    Delivery Method
                  </Form.Label>
                  <div className="row gap-5">
                    <Select
                      name="deliveryMethods"
                      options={deliveryMethodsOptions}
                      // value={deliveryMethods ? deliveryMethods : null}
                      value={
                        deliveryMethodsOptions?.filter(
                          (data) => data.value === deliveryMethods,
                        )[0]
                      }
                      onChange={handleChangeDeliveryMethod}
                      className={
                        errors.deliveryMethods ? "text-error border-error" : ""
                      }
                      classNamePrefix="select"
                    />
                  </div>
                </div>
                {deliveryMethods && deliveryMethods === "email" ? (
                  <div>
                    {fields?.length ? (
                      fields.map((item, index) => (
                        <div key={item.id} className="d-flex mb-3">
                          <Form.Control
                            {...register(`emails.${index}.email`, {
                              required: true,
                            })}
                            placeholder="Email Address"
                            className={
                              errors.emails?.[index]?.email
                                ? "text-error border-error me-3"
                                : "me-3"
                            }
                          />
                          <Button
                            variant="danger"
                            onClick={() => remove(index)}
                          >
                            Delete
                          </Button>
                        </div>
                      ))
                    ) : (
                      <div key={0} className="d-flex mb-3">
                        <Form.Control
                          {...register(`emails.0.email`, {
                            required: true,
                          })}
                          placeholder="Email Address"
                          className={
                            errors.emails?.[0]?.email
                              ? "text-error border-error me-3"
                              : "me-3"
                          }
                        />
                        {/* <Button variant="danger" onClick={() => remove(index)}>
                          Delete
                        </Button> */}
                      </div>
                    )}
                    <Button onClick={() => append({ email: "" })}>
                      Add Email
                    </Button>
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    <Form.Control
                      {...register("Host", { required: true })}
                      type={"text"}
                      placeholder="Host"
                      className={errors.Host ? "text-error border-error" : ""}
                    />
                    <Form.Control
                      {...register("Port", { required: true })}
                      type={"text"}
                      placeholder="Port"
                      className={errors.Port ? "text-error border-error" : ""}
                    />
                    <Form.Control
                      {...register("Username", { required: true })}
                      type={"text"}
                      placeholder="Username"
                      className={
                        errors.Username ? "text-error border-error" : ""
                      }
                    />
                    <EyeIconWrapper top="5px">
                      <div>
                        <Form.Control
                          {...register("password", { required: true })}
                          type={"password"}
                          placeholder="Password"
                          className={
                            errors.password ? "text-error border-error" : ""
                          }
                        />
                      </div>
                    </EyeIconWrapper>
                    <Form.Control
                      {...register("remote_directory", { required: true })}
                      type={"text"}
                      placeholder="Remote Directory"
                      className={
                        errors.remote_directory ? "text-error border-error" : ""
                      }
                    />
                  </div>
                )}
              </Form.Group>
              <Form.Group
                controlId="formBasicEmail"
                className="col-sm-6 border p-5"
              >
                <Form.Label className="">Report Parameters</Form.Label>
                <div className="form-group m-5">
                  <FloatLabel
                    label={"Selected Report"}
                    value={
                      prefilled
                        ? scheduledReportData?.selectedReportLabel
                        : reportDetailsInfoForScheduledReports?.report?.label
                    }
                  >
                    <input
                      type="text"
                      value={
                        prefilled
                          ? scheduledReportData?.selectedReportLabel
                          : reportDetailsInfoForScheduledReports?.report?.label
                      }
                      disabled={true}
                      className="form-control input-lg p-5"
                    />
                  </FloatLabel>
                </div>
                {updatedOptions?.find(
                  (option) => option.type === "lenderSelect",
                ) ? null : (
                  <div className={"row me-5 pt-5 ms-0"}>
                    <FloatLabel
                      label={"Selected Lenders"}
                      value={
                        prefilled
                          ? scheduledReportData?.selectedAccounts
                          : reportDetailsInfoForScheduledReports?.lenderID
                      }
                    >
                      <BlurWrapper>
                        <Select
                          name="lenderLoan"
                          isMulti
                          options={[
                            { label: "Select All", value: "all" },
                            ...accountOptions,
                          ]}
                          value={
                            prefilled
                              ? scheduledReportData?.selectedAccounts
                              : reportDetailsInfoForScheduledReports?.lenderID ||
                                null
                          }
                          placeholder=""
                          isDisabled
                          styles={customStylesForMultiSelect}
                        />
                      </BlurWrapper>
                    </FloatLabel>{" "}
                  </div>
                )}
                <div className="row mb-5">
                  {/* {optionsStatus === "fulfilled" ? ( */}
                  <FormBox
                    options={updatedOptions}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    disable={loading}
                  />
                  {/* ) : (
                    <SpinnerBlock />
                  )} */}
                </div>
              </Form.Group>
            </Form>
            <LoadingButton
              className="mt-5 me-5 btn btn-primary text-white"
              onClick={handleSubmit(onSubmit)}
              title={"Save"}
              loading={loading}
              disabled={loading}
            />
          </section>
        </article>
      </section>
    </div>
  );
};

export default ScheduleReport;
// data["Frequency"] = Object.fromEntries(
//   Object.entries({
//     Repeat: frequeRepeat,
//     Date:
//       frequeRepeat === "M"
//         ? frequeDate
//           ? new Date(frequeDate).getDate()
//           : null
//         : null,
//     Day: frequeRepeat === "W" ? frequeDay : null,
//     Time: frequeTime
//       ? moment(frequeTime, "HH:mm").format("hh:mm A")
//       : null,
//   }).filter(([_, v]) => v !== null)
// );

function to24HourFormat(time12h) {
  const [time, modifier] = time12h?.split(" ");
  let [hours, minutes] = time?.split(":");

  if (modifier === "PM" && hours !== "12") {
    hours = String(Number(hours) + 12);
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }

  return `${hours.padStart(2, "0")}:${minutes}`;
}

const reportFormatOptions = [
  { label: "XLSX", value: "XLSX" },
  { label: "PDF", value: "PDF" },
  { label: "HTML", value: "HTML" },
  { label: "CSV", value: "CSV" },
  { label: "XML", value: "XML" },
  { label: "JSON", value: "JSON" },
];
